import React from 'react'
import { MdDataThresholding } from 'react-icons/md'
import Layout from '../components/Layout/Layout'

const InvestorSection = () => {
    return (
        <>
            <div>
                <Layout>
                    <div className="container pt-5">
                        <div className="pt-5">
                            <video className="background-video" autoPlay muted loop>
                                <source src="/video/home1.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <section className="introduction mb-4 row justify-content-center align-items-center">
                                <div className="col-md-8">
                                    <h2 className="text_48_investor">Welcome to IMMSY Investments</h2>
                                    <h2 className="text_48_investor">Investment Opportunities</h2>
                                    <p className="text_18_investor ms-0">
                                        Join us in shaping the future of wellness with innovative investments.
                                    </p>
                                    <p className="text_18_investor ms-0">
                                        Our AI avatar will guide you through the investment process, explain the necessary details, and answer any questions you may have. Simply click on the avatar at any time for assistance.
                                    </p>
                                    <button className="btn btn-primary btn-start">Start Preauthorization</button>
                                </div>
                                <div className="ai-avatar col-md-4">
                                    <img src="/img/home1.jpg" alt="Black male avatar" className="avatar" />
                                </div>
                            </section>
                        </div>
                        <section className="access-process mb-4 row">
                            <div className="col-md-6">
                                <h2 className="text_48_investor">Get Started</h2>
                                <p className="text_18_investor">
                                    Start by filling out a preauthorization form. Our AI avatar will assist you throughout this process, explaining each field and answering any questions.
                                </p>
                                <p className="text_18_investor">
                                    Once validated, you'll receive a secure password via email to access our exclusive investment documents.
                                </p>
                            </div>
                        </section>
                        <section className="investor-documents mb-4 row">
                            <div className="col-md-12">
                                <h2 className="text_48_investor">Investment Documents</h2>
                                <ul className="document-list">
                                    {['Investment Overview', 'Business Plan', 'Financial Projections', 'Risk Assessment', 'Regulatory Compliance', 'Investment Terms', 'Team Overview', 'Use of Funds', 'Market Analysis'].map(doc => (
                                        <li key={doc} className="text_18_investor">
                                            <MdDataThresholding className="icon me-2" />
                                            {doc}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </section>
                        <div className="row">
                            <section className="security-compliance mb-4 col-md-6">
                                <h2 className="text_24_investor">Security and Compliance</h2>
                                <ul className="text_18_investor">
                                    <li>Data Encryption - All data encrypted to protect sensitive information.</li>
                                    <li>Access Control - Only authorized investors can access documents; all access is logged.</li>
                                    <li>Compliance with Regulations - Adheres to GDPR, MiFID II, and other relevant standards.</li>
                                </ul>
                            </section>
                            <section className="notifications-alerts mb-4 col-md-6">
                                <h2 className="text_24_investor">Notifications and Alerts</h2>
                                <p className="text_18_investor">
                                    Automated email alerts at key stages (preauthorization approval, document access, investment confirmation).
                                </p>
                                <p className="text_18_investor">
                                    Real-time reminders from the AI avatar about upcoming deadlines and important steps.
                                </p>
                            </section>
                        </div>

                    </div>
                </Layout>
            </div>
        </>
    )
}

export default InvestorSection

